// client/src/pages/NoticeDetailPage.js
// 공지 상세 — v5 리디자인 (nd 카드: 배지 + 제목 + 메타 + 본문 + 목록으로)
// meta 프리로드·조회 로직은 기존 그대로.
import React, { useEffect, useState } from 'react';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import Header from '../components/Header';
import InfluencerHomeHeader from '../components/influencer/InfluencerHomeHeader';
import MarketerHomeHeader from '../components/marketer/MarketerHomeHeader';
import { PointProvider } from '../contexts/PointContext';
import Footer from '../components/landing/Footer';
import '../styles/public/pub.css';

const API_URL = process.env.REACT_APP_API_URL || '';

function RoleHeader() {
  const loc = useLocation();
  const [role, setRole] = useState(() => {
    try { return loc.state?.role || sessionStorage.getItem('current_user_role'); } catch { return null; }
  });

  useEffect(() => {
    const hint = loc.state?.role;
    if (hint) {
      setRole(hint);
      try { sessionStorage.setItem('current_user_role', hint); } catch {}
    }
  }, [loc.state]);

  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const res = await fetch(`${API_URL}/api/user/me`, { credentials: 'include' });
        const j = await res.json().catch(()=>({}));
        if (!alive) return;
        const r = (res.ok && j?.ok && j?.user?.role) ? j.user.role : null;
        if (r) {
          setRole(r);
          try { sessionStorage.setItem('current_user_role', r); } catch {}
        }
      } catch {}
    })();
    return () => { alive = false; };
  }, []);

  if (role === 'influencer') {
    return (
      <PointProvider userRole="influencer">
        <InfluencerHomeHeader />
      </PointProvider>
    );
  }
  if (role === 'marketer') {
    return (
      <PointProvider userRole="marketer">
        <MarketerHomeHeader />
      </PointProvider>
    );
  }
  return <Header />;
}

const KIND_BADGE = {
  all: { label: '전체', cls: 'badge--gray' },
  marketer: { label: '광고주', cls: 'badge--blue' },
  influencer: { label: '인플루언서', cls: 'badge--mint' },
};

export default function NoticeDetailPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const loc = useLocation();
  const meta = loc.state?.meta; // { title, createdAt, important, kind }

  const [item, setItem] = useState(null);
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState('');

  useEffect(() => {
    let alive = true;
    (async () => {
      setLoading(true); setErr('');
      try {
        const r = await fetch(`${API_URL}/api/notices/${id}`, { credentials: 'include' });
        const j = await r.json().catch(()=>({}));
        if (!alive) return;
        if (!r.ok || !j?.ok) throw new Error(j?.message || `불러오기 실패(${r.status})`);
        setItem(j.item || null);
      } catch (e) {
        if (!alive) return;
        setErr(e.message || '불러오기 실패');
      }
      setLoading(false);
    })();
    return () => { alive = false; };
  }, [id]);

  const fmt = (ts) =>
    ts ? new Date(ts).toLocaleDateString('ko-KR', { year: 'numeric', month: 'long', day: 'numeric' }) : '';

  const kind = meta?.kind || item?.kind || 'all';
  const important = (meta?.important || item?.important) || false;
  const badge = KIND_BADGE[kind] || KIND_BADGE.all;

  return (
    <div className="pub">
      <RoleHeader />
      <main className="wrap">
        <div style={{ height: 24 }} />

        {loading && !meta && (
          <div className="nd" style={{ textAlign: 'center', color: '#6b7686', fontSize: 14, fontWeight: 600 }}>
            불러오는 중...
          </div>
        )}
        {err && !meta && !item && (
          <div className="nd">
            <div className="note note--red" style={{ marginTop: 0 }}>{err}</div>
            <div className="nd__foot">
              <button type="button" className="btn btn--ghost" onClick={() => navigate('/notice')}>목록으로</button>
            </div>
          </div>
        )}

        {(meta || item) && (
          <div className="nd">
            <div className="nd__head">
              <div style={{ display: 'flex', gap: 8 }}>
                {important && <span className="badge badge--red">중요</span>}
                <span className={`badge ${badge.cls}`}>{badge.label}</span>
              </div>
              <div className="nd__title">{meta?.title || item?.title || ''}</div>
              <div className="nd__meta num">{fmt(meta?.createdAt || item?.createdAt)} · 셀프애드 운영팀</div>
            </div>
            <div className="nd__body">
              {item?.content || '불러오는 중...'}
            </div>
            <div className="nd__foot">
              <button type="button" className="btn btn--ghost" onClick={() => navigate('/notice')}>목록으로</button>
            </div>
          </div>
        )}
      </main>
      <Footer />
    </div>
  );
}
